module.exports = __webpack_public_path__ + "assets/images/icons/mastercard_icon.dc34d2d91feb351a6541c8b75cce94e5.svg";